module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAV1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACxsbHR0dH4+Pj4+Pj7+/v7+/v////////////////////////dVnjjdZDlf5nlgJr0ytT31N3///8oWuPQAAAAFnRSTlMAAQIDBAUGBwgJFydyc4GCv8DP0O/w/Qjj7gAAANpJREFUKM+Nk1kWgyAMRZUAEociTlXL/tdZMXJEtNr3hVySB0lMkn+Vkn4gxgCAsYsDDnHhxN2BKJCBkJlCRJVJASwMXyCXqijrznZ1WSjJQ+wgauv1QodDmDd2V5PvePGU2NpQDUrYcMqE0vYorYSnIAsbq5CQbq5ZRVvzNEwzLauMnF1iQ3BwImy21CkI7Ned90rHdd2hAE8p20Cij4CeY3tPI9/P0Te48ziM0Z3v3/tUq3Od273O1KMQt3ncwqC/+tBfPxuV6W1vqng27ufqYSaf5vnhX7jUF2RfIcmBq+ilAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dott_filter.png
// module id = 663
// module chunks = 0